function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M640 320H448V0H192v320H0l320 384 320-384zM0 1024h640V832H0v192z"
});

var SvgIconMoveDown = function SvgIconMoveDown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 640 1024"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' ?%3E %3Csvg viewBox='0 0 640 1024' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M640 320H448V0H192v320H0l320 384L640 320zM0 1024h640V832H0V1024z' /%3E %3C/svg%3E";
export { SvgIconMoveDown as ReactComponent };